import { getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import { deactivateProfile, fetchUser, updateUser } from '@/store/api';
import { MRContactUser, UsersEntity } from '@/store/models';
import store from '@/store';

@Module({
  namespaced: true,
  name: 'userprofile',
  store,
  dynamic: true,
})
class UserProfileModule extends VuexModule {
  public userentity: UsersEntity | null = null;
  public mrcontactuser: MRContactUser | null = null;

  @MutationAction
  public async updateSelfProfile(userUpdateFields: UsersEntity) {
    const userentity = await updateUser(userUpdateFields);
    return { userentity };
  }

  @MutationAction
  public async updateContactUser(userUpdateFields: MRContactUser) {
    const mrcontactuser = await updateUser(userUpdateFields);
    return { mrcontactuser };
  }
}

export default getModule(UserProfileModule);
